import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface RegistrationConfirmationProps {
  open: boolean;
  onClose: () => void;
  email?: string;
  variant?: 'default' | 'hoofdhart';
}

export function RegistrationConfirmation({
  open,
  onClose,
  email = 'je e-mail',
  variant = 'default',
}: RegistrationConfirmationProps) {
  const isHoofdhart = variant === 'hoofdhart';
  const appName = isHoofdhart ? 'Van Hoofd naar Hart' : 'Hoofdzorg Naar Hartzorg';

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className={`text-xl ${isHoofdhart ? 'text-red-700' : 'text-green-600'}`}>
            Bedankt voor je registratie!
          </AlertDialogTitle>
          <AlertDialogDescription className="text-base">
            <p className="mb-4">
              We hebben een bevestigingslink gestuurd naar{' '}
              <strong>{email}</strong>.
            </p>
            <p className="mb-4">
              Klik op de link in je e-mail om je account te activeren en toegang
              te krijgen tot de {appName} app.
            </p>
            <p className="text-sm text-muted-foreground">
              Controleer je spam/ongewenste e-mail als je de e-mail niet kunt
              vinden.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            className={isHoofdhart ? 'bg-red-700 hover:bg-red-600' : 'bg-green-600 hover:bg-green-700'}
            onClick={() => (window.location.href = '/')}
          >
            Begrepen
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
